<div fxLayout="column" [ngClass]="{ 'my-4': isNeedVerticalMargin }">
  <div fxFlex="100%" fxLayoutGap="20px" class="ml-4 mr-4" *ngIf="isShowFilter">
    <vex-multiple-selection-select-all fxFlex #MultipleSelectionSelectAllComponent [data]="filterAttribute"
      [form]="form" [selectionValues]="resources" [isShowRefreshButton]="false" [isShowCustomLabel]="false"
      (selectionChange)="onChangeResourcefilter($event)">
    </vex-multiple-selection-select-all>
    <mat-form-field fxFlex>
      <mat-label>Search</mat-label>
      <input type="text" [(ngModel)]="searchResource" matInput (ngModelChange)="searchResources$.next($event)" />
    </mat-form-field>
    <div #originRef matTooltipPosition="right">
      <button type="button" style="height: 52px" mat-raised-button color="primary" (click)="showPopover(originRef)">
        <mat-icon [icIcon]="icSettingOutline" style="font-size: 25px"></mat-icon>
      </button>
    </div>
    <button type="button" style="height: 52px" mat-raised-button color="primary" (click)="onReset()">
      <mat-icon [icIcon]="icClose" style="font-size: 25px"></mat-icon>
    </button>
  </div>

  <div *ngIf="!dataSource || !treeControl || isSearch; else content1" fxLayout="row" fxLayoutAlign="space-around center">
    <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <ng-template #content1>
    <div *ngIf="hasNoResults()" class="ml-4 mr-4 mt-4 text-secondary">
      No results found.
    </div>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <button mat-icon-button disabled (click)="onResourceToggle(node)"></button>
        <div *ngIf="!isCheckbox" class="parent-node-icon">
            <div class="tree-node-header">
              <b id="{{ node.item }}" [ngClass]="{ 'bg-amber': node.colorStatus }">
                <span (click)="nodeClick(node)" style="cursor: pointer">
                  <span class="primary">{{ node.item }}</span>:
                  {{ node.ItemName }}
                </span>
              </b>
                <ng-container *ngIf="node.isShowAttribute">
                  <span *ngIf="showResourceStateLabel" class="label ml-1 py-1"
                    style="opacity: 1" fxFlex="none" [ngClass]="node.resourceState?.LblClass || 'lbl-initiated'">
                    {{ node.resourceState?.Value || 'N/A' }}
                  </span>
                  <span *ngIf="isShowStateDetail" class="label ml-1 py-1" style="opacity: 1" fxFlex="none"
                    [ngClass]="node?.stateDetailStatus?.LblClass || 'lbl-initiated'">
                    {{ node?.stateDetailStatus?.Value || 'N/A' }}
                  </span>
                </ng-container>  
            </div>
            <ng-container *ngIf="node.isShowAttribute && !compactMode">
                <ng-container *ngIf="isShowUserProvider">
                  <button type="button" mat-icon-button (click)="expandView(node, 'isUserExpanded')">
                    <span class="material-icons material-icons-two-tone" *ngIf="!node.isUserExpanded">
                      arrow_right
                    </span>
                    <span class="material-icons material-icons-two-tone" *ngIf="node.isUserExpanded">
                      arrow_drop_down
                    </span>
                    User Provided Values
                  </button>
                  <div *ngIf="node.isUserExpanded" class="pl-5">
                    <div class="activity">
                      <span *ngIf="node.UserAttributes" [innerHTML]="node.UserAttributes">
                      </span>
                      <span *ngIf="!node.UserAttributes"> N/A </span>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="showCSPFields && isShowServiceProvider">
                  <br />
                  <button type="button" mat-icon-button (click)="expandView(node, 'isCSPExpanded')">
                    <span class="material-icons material-icons-two-tone" *ngIf="!node.isCSPExpanded">
                      arrow_right
                    </span>
                    <span class="material-icons material-icons-two-tone" *ngIf="node.isCSPExpanded">
                      arrow_drop_down
                    </span>
                    Service Provider Value
                  </button>
                  <div *ngIf="node.isCSPExpanded" class="pl-5">
                    <div class="activity">
                      <span *ngIf="node.CSPAttributes" [innerHTML]="node.CSPAttributes">
                      </span>
                      <span *ngIf="!node.CSPAttributes"> N/A </span>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="isShowDeployedServices">
                  <br />
                  <button type="button" mat-icon-button (click)="expandView(node, 'isDeployedServiceExpanded')">
                    <span class="material-icons material-icons-two-tone" *ngIf="!node.isDeployedServiceExpanded">
                      arrow_right
                    </span>
                    <span class="material-icons material-icons-two-tone" *ngIf="node.isDeployedServiceExpanded">
                      arrow_drop_down
                    </span>
                    Dependent Services
                  </button>
                  <div *ngIf="node.isDeployedServiceExpanded" class="pl-5">
                    <div class="activity">
                      <span *ngIf="node.DeployedServices?.length > 0" [innerHTML]="node.DeployedServicesHtml">
                      </span>
                      <span *ngIf="!node.DeployedServices?.length">No Dependent Service Found</span>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="isShowStateDetail">
                  <br />
                  <button type="button" mat-icon-button (click)="expandView(node, 'isStateDetailExpanded')">
                    <span class="material-icons material-icons-two-tone" *ngIf="!node?.isStateDetailExpanded">
                      arrow_right
                    </span>
                    <span class="material-icons material-icons-two-tone" *ngIf="node?.isStateDetailExpanded">
                      arrow_drop_down
                    </span>
                    State Details
                  </button>
                  <ul *ngIf="node?.isStateDetailExpanded" class="pl-8 mb-4">
                    <li>
                      <span>
                        Criteria
                      </span>
                      <ul class="pl-4">
                        <li *ngFor="let benchmark of node?.StateDetail?.Benchmarks">
                          <span (click)="openBenchmarkDetail(benchmark.BenchmarkId)" class="cursor-pointer">
                            <span class="text-primary underline">
                              {{ benchmark.BenchmarkName }}
                            </span>
                            <ic-icon color="primary" [icon]="icExternalLink" class="mx-1 link-icon-color" inline="true" size="15px" *ngIf="benchmark?.BenchmarkId"></ic-icon>
                          </span>
                          <ul class="pl-4">
                            <li *ngFor="let policy of benchmark?.Policies">
                              <span (click)="openPolicyDetail(policy.PolicyId)" class="cursor-pointer">
                                <span class="text-primary underline">
                                  {{ policy.PolicyName }}
                                </span>
                                <ic-icon color="primary" [icon]="icExternalLink" class="mx-1 link-icon-color" inline="true" size="15px" *ngIf="policy?.PolicyId"></ic-icon>
                              </span>
                            </li>
                          </ul>
                        </li>
                        <span *ngIf="!node?.StateDetail">No Device State Found</span>
                      </ul>
                    </li>
                    <li>
                      <span>
                        Operational Data
                      </span>
                      <ul>
                        <div fxLayout="row" *ngIf="node?.StateDetail?.BlueprintCollections.length > 0">
                          <div fxFlex="auto">
                            <inventory-tree [showCSPFields]="false" [showAuditFields]="false" [isInventory]="false"
                              [isCheckbox]="false" [onlyMandatory]="false" [isShowFilter]="false" [startWithChild]="true"
                              [IsCollectionEntryAttributeId]="true"
                              [showResourceStateLabel]="showResourceStateLabel"
                              [BlueprintCollections]="node?.StateDetail.BlueprintCollections">
                            </inventory-tree>
                          </div>
                        </div>
                        <span *ngIf="!node?.StateDetail || !node?.StateDetail?.BlueprintCollections.length">No Operational
                          Data Found</span>
                      </ul>
                    </li>
                  </ul>
                </ng-container>
                <ng-container *ngIf="showAuditFields && isShowAudit">
                  <br />
                  <button type="button" mat-icon-button (click)="expandView(node, 'isAuditExpanded')">
                    <span class="material-icons material-icons-two-tone" *ngIf="!node.isAuditExpanded">
                      arrow_right
                    </span>
                    <span class="material-icons material-icons-two-tone" *ngIf="node.isAuditExpanded">
                      arrow_drop_down
                    </span>
                    Audit
                  </button>
                  <div *ngIf="node.isAuditExpanded" class="pl-5">
                    <div class="activity">
                      <ng-container *ngIf="node.IsShowAudit">
                        <div class="event" fxLayout="row">
                          <div class="dot primary"></div>
                          <div class="line"></div>
                          <div class="info">
                            <div class="name">Created</div>
                            <div class="description" *ngIf="node.CreatedBy || node.UpdatedBy">
                              <span class="text-black font-black">
                                {{ node.CreatedBy ? node.CreatedBy : node.UpdatedBy || 'N/A' }}
                              </span>
                            </div>
                            <div class="description" *ngIf="node.CreatedDate || node.UpdatedDate">
                              <span class="text-black font-black">
                                {{
                                  node.CreatedDate
                                    ? (node.CreatedDate | dateFormat)
                                    : node.UpdatedDate
                                      ? (node.UpdatedDate | dateFormat)
                                      : ''
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="event" fxLayout="row">
                          <div class="dot primary"></div>
                          <div class="line"></div>
                          <div class="info">
                            <div class="name">Changed</div>
                            <div class="description" *ngIf="node.CreatedBy || node.UpdatedBy">
                              <span class="text-black font-black">
                                {{ node.UpdatedBy ? node.UpdatedBy : node.CreatedBy || 'N/A' }}
                              </span>
                            </div>
                            <div class="description" *ngIf="node.CreatedDate || node.UpdatedDate">
                              <span class="text-black font-black">
                                {{
                                  node.UpdatedDate
                                    ? (node.UpdatedDate | dateFormat)
                                    : node.CreatedDate
                                      ? (node.CreatedDate | dateFormat)
                                      : ''
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="event" fxLayout="row" *ngIf="node.ResourceStateMessage">
                          <div class="dot primary"></div>
                          <div class="line"></div>
                          <div class="info">
                            <div class="name">Message</div>
                            <div class="description">
                              <span class="text-black font-black">
                                {{ node.ResourceStateMessage || 'N/A' }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <span *ngIf="!node.IsShowAudit"> N/A </span>
                    </div>
                  </div>
                </ng-container>
            </ng-container>
        </div>
      </mat-tree-node>

      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding style="align-items: 'start'">
        <button type="button" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename"
          (click)="onResourceToggle(node)">
          <mat-icon class="mat-icon-rtl-mirror material-icons-two-tone" class="-mt-4">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>

        <div *ngIf="!isCheckbox" class="parent-node-icon">
          <div fxLayout="row" fxLayoutAlign="start start" class="tree-node-header">
            <b id="{{ node.item }}" [ngClass]="{ 'bg-amber': node.colorStatus }">
              <span (click)="nodeClick(node)" style="cursor: pointer">
                <span class="primary">{{ node.level === 0 ? 'Provider' : node.item }}</span>:
                {{ node.ItemName }}
              </span>
            </b>
            <ng-container *ngIf="node.isShowAttribute">
              <span *ngIf="showResourceStateLabel" class="label ml-1 py-1"
                style="opacity: 1" fxFlex="none" [ngClass]="node.resourceState?.LblClass || 'lbl-initiated'">
                {{ node.resourceState?.Value || 'N/A' }}
              </span>
              <span *ngIf="isShowStateDetail" class="label ml-1 py-1" style="opacity: 1" fxFlex="none"
                [ngClass]="node?.stateDetailStatus?.LblClass || 'lbl-initiated'">
                {{ node?.stateDetailStatus?.Value || 'N/A' }}
              </span>
            </ng-container>
            <div *ngIf="node.level == 0 && !compactMode" class="ml-8 underline text-primary" style="cursor: pointer;">
              <a *ngIf="!node.isDetailsExpanded" (click)="collapseNodeValue(node, true);collapseNodeData(node, true)">
                Show details
              </a>
              <a *ngIf="node.isDetailsExpanded" (click)="collapseNodeValue(node, false);collapseNodeData(node, false)">
                Hide details
              </a>
            </div>
          </div>
          <ng-container *ngIf="node.isShowAttribute && !compactMode">
            <ng-container *ngIf="isShowUserProvider">
              <button type="button" mat-icon-button (click)="expandView(node, 'isUserExpanded')">
                <span class="material-icons material-icons-two-tone" *ngIf="!node.isUserExpanded">
                  arrow_right
                </span>
                <span class="material-icons material-icons-two-tone" *ngIf="node.isUserExpanded">
                  arrow_drop_down
                </span>
                User Provided Values
              </button>

              <div *ngIf="node.isUserExpanded" class="pl-5">
                <div class="activity">
                  <span *ngIf="node.UserAttributes" [innerHTML]="node.UserAttributes">
                  </span>
                  <span *ngIf="!node.UserAttributes"> N/A </span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="showCSPFields && isShowServiceProvider">
              <br />
              <button type="button" mat-icon-button (click)="expandView(node, 'isCSPExpanded')">
                <span class="material-icons material-icons-two-tone" *ngIf="!node.isCSPExpanded">
                  arrow_right
                </span>
                <span class="material-icons material-icons-two-tone" *ngIf="node.isCSPExpanded">
                  arrow_drop_down
                </span>
                Service Provider Value
              </button>
              <div *ngIf="node.isCSPExpanded" class="pl-5">
                <div class="activity">
                  <span *ngIf="node.CSPAttributes" [innerHTML]="node.CSPAttributes">
                  </span>
                  <span *ngIf="!node.CSPAttributes"> N/A </span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="isShowDeployedServices">
              <br />
              <button type="button" mat-icon-button (click)="expandView(node, 'isDeployedServiceExpanded')">
                <span class="material-icons material-icons-two-tone" *ngIf="!node.isDeployedServiceExpanded">
                  arrow_right
                </span>
                <span class="material-icons material-icons-two-tone" *ngIf="node.isDeployedServiceExpanded">
                  arrow_drop_down
                </span>
                Dependent Services
              </button>
              <div *ngIf="node.isDeployedServiceExpanded" class="pl-5">
                <div class="activity">
                  <span *ngIf="node.DeployedServices?.length > 0" [innerHTML]="node.DeployedServicesHtml">
                  </span>
                  <span *ngIf="!node.DeployedServices?.length">No Dependent Service Found</span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="isShowStateDetail">
              <br />
              <button type="button" mat-icon-button (click)="expandView(node, 'isStateDetailExpanded')">
                <span class="material-icons material-icons-two-tone" *ngIf="!node?.isStateDetailExpanded">
                  arrow_right
                </span>
                <span class="material-icons material-icons-two-tone" *ngIf="node?.isStateDetailExpanded">
                  arrow_drop_down
                </span>
                State Details
              </button>
              <ul *ngIf="node?.isStateDetailExpanded" class="pl-12 mb-4">
                <li>
                  <span>
                    Criteria
                  </span>
                  <ul class="pl-4">
                    <li *ngFor="let benchmark of node?.StateDetail?.Benchmarks">
                      <span  (click)="openBenchmarkDetail(benchmark.BenchmarkId)" class="cursor-pointer">
                        <span class="text-primary underline">
                          {{ benchmark.BenchmarkName }}
                        </span>
                        <ic-icon color="primary" [icon]="icExternalLink" class="mx-1 link-icon-color" inline="true" size="15px" *ngIf="benchmark?.BenchmarkId"></ic-icon>
                      </span>
                      <ul class="pl-4">
                        <li *ngFor="let policy of benchmark?.Policies">
                          <span (click)="openPolicyDetail(policy.PolicyId)" class="cursor-pointer">
                            <span class="text-primary underline">
                              {{ policy.PolicyName }}
                            </span>
                            <ic-icon color="primary" [icon]="icExternalLink" class="mx-1 link-icon-color" inline="true" size="15px" *ngIf="policy?.PolicyId"></ic-icon>
                          </span>
                        </li>
                      </ul>
                    </li>
                    <span *ngIf="!node?.StateDetail">No Device State Found</span>
                  </ul>
                </li>
                <li>
                  <span>
                    Operational Data
                  </span>
                  <ul>
                    <div fxLayout="row" *ngIf="node?.StateDetail?.BlueprintCollections.length > 0">
                      <div fxFlex="auto">
                        <inventory-tree [showCSPFields]="false" [showAuditFields]="false" [isInventory]="false"
                          [isCheckbox]="false" [onlyMandatory]="false" [isShowFilter]="false" [startWithChild]="true"
                          [IsCollectionEntryAttributeId]="true"
                          [showResourceStateLabel]="showResourceStateLabel"
                          [BlueprintCollections]="node?.StateDetail.BlueprintCollections">
                        </inventory-tree>
                      </div>
                    </div>
                    <span *ngIf="!node?.StateDetail || !node?.StateDetail?.BlueprintCollections.length">No Operational
                      Data Found</span>
                  </ul>
                </li>
              </ul>
            </ng-container>
            <ng-container *ngIf="showAuditFields && isShowAudit">
              <br />
              <button type="button" mat-icon-button (click)="expandView(node, 'isAuditExpanded')">
                <span class="material-icons material-icons-two-tone" *ngIf="!node.isAuditExpanded">
                  arrow_right
                </span>
                <span class="material-icons material-icons-two-tone" *ngIf="node.isAuditExpanded">
                  arrow_drop_down
                </span>
                Audit
              </button>
              <div *ngIf="node.isAuditExpanded" class="pl-5">
                <ng-container *ngIf="node.IsShowAudit">
                  <div class="activity">
                    <div class="event" fxLayout="row">
                      <div class="dot primary"></div>
                      <div class="line"></div>
                      <div class="info">
                        <div class="name">Created</div>
                        <div class="description" *ngIf="node.UpdatedBy || node.CreatedBy">
                          <span class="text-black font-black">
                            {{ node.CreatedBy ? node.CreatedBy : node.UpdatedBy || 'N/A' }}
                          </span>
                        </div>
                        <div class="description" *ngIf="node.CreatedDate || node.UpdatedDate">
                          <span class="text-black font-black">
                            {{
                              node.CreatedDate
                                ? (node.CreatedDate | dateFormat)
                                : node.UpdatedDate
                                  ? (node.UpdatedDate | dateFormat)
                                  : ''
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="event" fxLayout="row">
                      <div class="dot primary"></div>
                      <div class="line"></div>
                      <div class="info">
                        <div class="name">Changed</div>
                        <div class="description" *ngIf="node.UpdatedBy || node.CreatedBy">
                          <span class="text-black font-black">
                            {{ node.UpdatedBy ? node.UpdatedBy : node.CreatedBy || 'N/A' }}
                          </span>
                        </div>
                        <div class="description" *ngIf="node.CreatedDate || node.UpdatedDate">
                          <span class="text-black font-black">
                            {{
                              node.UpdatedDate
                                ? (node.UpdatedDate | dateFormat)
                                : node.CreatedDate
                                  ? (node.CreatedDate | dateFormat)
                                  : ''
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="event" fxLayout="row" *ngif="node.ResourceStateMessage">
                      <div class="dot primary"></div>
                      <div class="line"></div>
                      <div class="info">
                        <div class="name">Message</div>
                        <div class="description">
                          <span class="text-black font-black">
                            {{ node.ResourceStateMessage || 'N/A' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <span *ngIf="!node.IsShowAudit"> N/A </span>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </mat-tree-node>
    </mat-tree>
  </ng-template>
</div>
